import CurrentWeatherDetailsSection from './CurrentWeatherDetailsSection';
import CurrentWeatherSection from './CurrentWeatherSection';

export const Sections = {
  CurrentWeatherDetailsSection,
  CurrentWeatherSection,
};
